import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../../services/base-component.service';
import { AslibGridComponent } from '@aslib/components';

@Component({
  selector: 'gpa-empenho-nao-processado',
  templateUrl: './nao-processado.component.html',
  providers: [BaseComponentService]
})

export class NaoProcessadoComponent extends BaseComponentService implements OnInit {

  listaNaoProcessado: any[];
  desabilitarReenviar: boolean;

  ngOnInit() {
    this.listaNaoProcessado = [];
    this.desabilitarReenviar = true;

    // Se não vai por bem vai por mal
    if (sessionStorage.getItem('IdPed') != null) {
      const ped = Number(sessionStorage.getItem('IdPed'));
      this.getPEDNotProcessed(ped);
    } else {
      this.listaNaoProcessado = [];
    }

  }

  getPEDNotProcessed(fileId: number) {
    this.listaNaoProcessado = [];
    const rota = '/api/PedRetorno/ObterPedsRetornados'.concat(`/${fileId}/${false}`);

    this._service.routePrefix = rota;
    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {
      this.aslibLoadingService.complete();
      this.listaNaoProcessado = data;

      if (!this.listaNaoProcessado) {
        this.exibirAviso('Arquivo em processamento.');
      }

    },
      (error) => {
        this.aslibLoadingService.complete();
        this.exibirErro(error);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );

  }

  enviarPED(grid: AslibGridComponent) {
    if (this.listaNaoProcessado.length === 0) {
      this.exibirAviso('Não há dados para a geração PED.');
      return;
    }

    this.aslibLoadingService.start();

    this._service.routePrefix = '/api/PedEnvio';
    this.subSave = this._service.add(this.listaNaoProcessado, 'gpa').subscribe(data => {
      this.desabilitarReenviar = true;

      // atualiza a coluna de sinalização de envio.
      for (let index = 0; index < this.listaNaoProcessado.length; index++) {
        this.listaNaoProcessado[index].mensagemErro = null;
      }

      this.exibirSucesso('Os PEDs foram reenviados com sucesso.');
    },
      erro => {
        this.aslibLoadingService.complete();
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/pagamento/empenho/nao-processado/nao-processado.component.ts